import styled from 'styled-components';

import MotifCard from '@ey/motif-react-wrapper/Card';

export default styled(MotifCard)`
	&.motif-card-full-width {
		width: unset;
		min-width: 0;
		.motif-card-header {
			min-width: 0;
		}
	}
`;
